// extracted by mini-css-extract-plugin
export var chevronRight = "bp_dc";
export var link = "bp_b5";
export var variant1 = "bp_bH";
export var variant2 = "bp_bJ";